// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zCO9","image":"Header_image__3nqCf","name":"Header_name__2sZXw","info":"Header_info__17CVl","infoRow":"Header_infoRow__4ZcDt"};